export enum LibraryTagKeys {
  preSelectedWithIdp = 'pre-selected-with-idp',
  givesDs3Access = 'gives-ds3-access',
  suppressInteractiveDownload = 'suppress-interactive-download',
  downloadWithoutAddress = 'downloadWithoutAddress',
}
